import {
    pressRoomKeyRequestList,
    pressRoomKeyRequestByID,
} from '@/services/agency/pressRoomKeyRequests.service'

export default {
    namespaced: true,
    state: {
        keyRequestList: { meta: { pagination: { total: 0 } } },
        keyRequest: {},
        keyRequestStatus: 'pending',
    },
    getters: {
        getKeyRequestList(state) { return state.keyRequestList },
        getKeyRequest(state) { return state.keyRequest },
        getKeyRequestStatus(state) { return state.keyRequestStatus },
    },
    mutations: {
        KEY_REQUEST_LIST(state, value) { state.keyRequestList = value },
        SET_KEY_REQUEST(state, value) { state.keyRequest = value },
        KEY_REQUEST_STATUS(state, value) { state.keyRequestStatus = value },
    },
    actions: {
        async fetchKeyRequestList({ commit }, params) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            commit('KEY_REQUEST_STATUS', 'pending')
            commit('KEY_REQUEST_LIST', { meta: { pagination: { total: 0 } } })
            try {
                const { data } = await pressRoomKeyRequestList(params)
                commit('KEY_REQUEST_STATUS', 'init')
                commit('KEY_REQUEST_LIST', data)
                return data
            } catch (error) {
                commit('KEY_REQUEST_STATUS', 'init')
                throw error
            }
        },
        async fetchKeyRequestByID({ commit }, id) {
            commit('KEY_REQUEST_STATUS', 'pending')
            try {
                const { data } = await pressRoomKeyRequestByID(id)
                commit('KEY_REQUEST_STATUS', 'init')
                commit('SET_KEY_REQUEST', data.data)
                return data
            } catch (error) {
                commit('KEY_REQUEST_STATUS', 'init')
                return error
            }
        },
    },
}
